import {BaseApi} from './base-api';
import Vue from 'vue';

export class TransactionApi extends BaseApi {
  static apiUri = 'transactions';

  /** @return {Promise<PagedHttpResponse<TransactionDto>>} */
  static getAll () {
    return super.getAll();
  }

  /** @return {Promise<EntityHttpResponse<TransactionDto>>} */
  static getById (id) {
    return super.getById(id);
  }

  /** @param transactionIds {number[]|number} */
  static getTransactionsSepa (transactionIds) {
    if (typeof transactionIds === 'number') {
      transactionIds = [transactionIds];
    }
    return Vue.http.post(this.apiUri + '/sepa', {transactionIds: transactionIds}, {responseType: 'arraybuffer'});
  }

  /** @return {Promise<EntityHttpResponse<NotDownloadedTransactionsCount>>} */
  static getNotDownloadedTransactionsCount () {
    return Vue.http.get(this.apiUri + '/sepa/not-downloaded', null);
  }

  static getNotDownloadedTransactionsSepa () {
    return Vue.http.post(this.apiUri + '/sepa/not-downloaded', null, {responseType: 'arraybuffer', timeout: 60 * 1000});
  }

  /** @param bookingIds {number[]|number} */
  static createRefundTransactionFromBookings (bookingIds) {
    if (typeof bookingIds === 'number') {
      bookingIds = [bookingIds];
    }
    return Vue.http.post(this.apiUri + '/from-bookings', {bookingIds: bookingIds});
  }

  static markBookingsWithNoRefundAsNotNeeded () {
    return Vue.http.post(this.apiUri + '/not-needed');
  }

  /**
   * @param transactionId {number}
   * @param updateRequest {TransactionUpdateRequest}
   * @returns {Promise<HttpResponse>}
   */
  static updateTransaction (transactionId, updateRequest) {
    return Vue.http.patch(this.apiUri + '/' + transactionId + '', updateRequest);
  }

  /**
   * @return {Promise<HttpResponse<ArrayBuffer>>}
   * @param {number} transactionId
   */
  static downloadPdf(transactionId) {
    return Vue.http.get(this.apiUri + '/' + transactionId + '/pdf', {responseType: 'arraybuffer'});
  }
}
